import { render, staticRenderFns } from "./LbaDialogRecommendEmpty.vue?vue&type=template&id=4870dbce"
import script from "./LbaDialogRecommendEmpty.vue?vue&type=script&lang=js"
export * from "./LbaDialogRecommendEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports